<template>
	<div class="events">
		<div class="layout">
			<h2>Upcoming events</h2>
			<div class="week-grid">
				<div class="day-literal" v-for="day in ['lun', 'mar', 'mer', 'gio', 'ven', 'sab', 'dom']" :key="day">{{ day }}</div>

				<div class="month-day" v-for="i in 14" :key="i">
					<div class="day-number" :class="{'today': $moment().day(0).add(i, 'days').isSame($moment(), 'day')}">
						<span>{{ $moment().day(0).add(i, 'days').date() }}</span>
					</div>

					<div class="day-events">
						<div class="event" v-for="ev in eventsPerDay[i - 1]" :key="ev.id"
							:class="{'full': ev.numSubs >= 6, 'disp1': ev.numdisp == 1, 'disp2': ev.numdisp == 2, 'disp3': ev.numdisp == 3, 'disp4': ev.numdisp == 4, 'disp5': ev.numdisp == 5, 'disp6': ev.numdisp == 6, 'past': $moment(ev.start.dateTime).isBefore($moment())}"
							@click="showManageEvent(ev)">
							<div class="name">{{ ev.summary }}</div>
							<div class="info">
								<span class="far fa-clock fa-fw"></span>
								<span class="time">{{ ev.start.dateTime | moment('HH:mm') }}</span>
								<span style="margin: auto 0.4em;">&bull;</span>
								<span class="availability"></span>
							</div>
							<div class="numposti">
									<span class="posti"></span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="upcoming">
				<div v-for="event in upcoming" :key="event.id" class="event">
					<div class="info">
						<div class="date">
							<div class="day">{{ event.start.dateTime | moment('DD') }}</div>
							<div class="month">{{ event.start.dateTime | moment('MMM') }}</div>
						</div>

						<div>
							<div class="title">{{ event.summary }}</div>
							<div class="time">{{ event.start.dateTime | moment('HH:mm') }}</div>
						</div>
					</div>

					<div class="subs">
						<UserPicture class="sub" v-for="(sub, i) in event.subs" :key="sub.user.id"
							:class="{'dropped': sub.b_dropped, 'dropped2': sub.b_dropped2}"
							:src="'https://ui-avatars.com/api/?name=' + sub.user.first_name + '+' + sub.user.last_name + '&size=64&length=4&font-size=0.3'" :style="{'left': (i * 0) + 'em'}"
							@click.native="showSubDetails(sub)"/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment'
import { api } from '@/api'
import { pop, notif } from '@/pop'

export default {
	name: 'events',

	data() {

		return {
			// List of upcoming events
			upcoming: []
		}
	},

	computed: {
		/**
		 * 
		 */
		eventsPerDay() {

			let events = []
			let start = this.$moment().day(1).startOf('day')

			const numEvents = this.upcoming.length
			for (let day = 0, i = 0; day < 28; ++day)
			{
				// Create new day
				let today = this.$moment(start).add(day, 'd')
				let dayEvents = events[events.push([]) - 1]

				while (i < numEvents)
				{
					const event = this.upcoming[i]
					const startDate = this.$moment(event.start.dateTime)

					if (startDate.date() === today.date())
					{
						dayEvents.push(event)
						i++
					}
					else break
				}
			}

			return events
		}
	},

	methods: {
		/**
		 * 
		 */
		showManageEvent(event) {

			pop.push({
				props: {
					comp: () => import('./ManageEventDialog'),
					event
				},
				on: {
					'sub': (sub) => event.subs.push(sub),
					'unsub': (sub) => {

						let idx = event.subs.findIndex(({ user: { id } }) => id === sub.user.id)
						if (idx !== -1) event.subs.splice(idx, 1)
					}
				}
			})
		},

		/**
		 *
		 */
		showSubDetails(sub) {
			
			pop.push({
				props: {
					comp: () => import('./EventSubDialog'),
					sub
				},
				on: {
					'sub': (updated) => {
						
						console.log(updated)
						Object.assign(sub, updated)
					}
				}
			}, 'admin')
		}
	},

	async beforeRouteEnter(to, from, next) {

		let Event = api.event()
		let weekStart = moment().day(1).startOf('day')
		let weekEnd = moment(weekStart).add(14, 'd')

		try
		{
			// Load events and subscribers
			let upcoming = await Event.getRange({from: weekStart.format(), to: weekEnd.format()})
			let subs = await Promise.all(upcoming.map(({ id }) => Event.getSubs(id)))

			console.log(upcoming)
			
			// Embed in events
			upcoming.forEach((ev, i) => Object.assign(ev, {subs: subs[i]}))

			next((vm) => vm.upcoming = upcoming)
		}
		catch (e)
		{
			console.error(e)
			notif.error('Could not fetch events')
		}
	}
}
</script>

<style lang="stylus" scoped>
.events
	.layout
		margin 10vh auto

		.week-grid
			display grid
			grid-template-columns repeat(7, 2fr)
			grid-template-rows auto
			grid-gap 0.5em

			margin 2em auto

			.day-literal
				padding 0.5em
				border-bottom 2px dashed secondary

				color secondary

				font-weight bold
				text-align center
				text-transform uppercase

			.month-day
				position relative

				padding 0.6em
				border-bottom 1px dashed darkish

				.day-number
					display flex
					justify-content center

					>span
						width 1.5em
						height 1.5em

						display flex
						justify-content center
						align-items center

						padding 0.2em
						border-radius 50%

						color secondary

						font-family fontSans
						font-weight bold

						text-align center

					&.today
						>span
							background-color primary
							color dark
				
				.day-events
					.disp1:not(.past)
						.numposti
							.posti
								font-size 0.75em
								color darkblue

								&:before
									content ' 1 posto disponibile'
					.disp2:not(.past)
						.numposti
							.posti
								font-size 0.75em
								color darkblue
								
								&:before
									content ' 2 posti disponibili'
					.disp3:not(.past)
						.numposti
							.posti
								font-size 0.75em
								color darkblue
								
								&:before
									content ' 3 posti disponibili'
					.disp4:not(.past)
						.numposti
							.posti
								font-size 0.75em
								color darkblue
								
								&:before
									content ' 4 posti disponibili'
					.disp5:not(.past)
						.numposti
							.posti
								font-size 0.75em
								color darkblue
								
								&:before
									content ' 5 posti disponibili'
					.disp6:not(.past)
						.numposti
							.posti
								font-size 0.75em
								color darkblue
								
								&:before
									content ' 6 posti disponibili'
					.event
						margin 0.4em 0
						padding 0.4em 0.6em
						border-radius 0.4em

						background-color mix(secondary, light)
						color dark

						cursor pointer

						.name
							margin-bottom 0.2em

							font-size 1.1em
							font-weight bold
						
						.info
							display flex
							align-items center

							.time
								margin-left 0.2em

							.availability
								&:before
									content 'Disponibile'

									white-space nowrap
						&.past
							opacity 0.5
							filter grayscale(1)

							cursor not-allowed
						&:not(.past)
							&.enrolled
								background-color primary

								.availability
									&:before
										content 'Prenotato'

								&.dropped
									border 2px solid coral

									background-color dark
									color light

									.availability
										&:before
											content 'Da recuperare'
							&:not(.enrolled)
								&.full
									opacity 0.5

									.availability
										&:before
											content 'Chiuso'

		.upcoming
			display grid
			grid-template-columns auto
			grid-template-rows auto
			grid-gap 1em

			.event
				display flex
				justify-content space-between
				align-items center

				padding 1em
				border-radius 1em

				background-color darker

				.info
					display flex
					justify-content flex-start
					align-items center

					.date
						padding 1em
						border-right 2px solid secondary
						margin-right 1em

						text-align center

						.day
							color secondary

							font-size 1.8em
							font-weight bold
						
						.month
							font-size 0.8em
							font-weight bold
							text-transform uppercase

					.title
						color primary

						font-size 1.5em
						font-weight bold
					
					.time
						font-size 0.8em
				
				.subs
					display flex
					flex-direction row-reverse
					align-items center

					.sub
						width 3.5em
						height 3.5em

						margin auto 0.5em
						box-sizing border-box

						position relative

						cursor pointer

						border 2px solid #232b34

						border-radius 50%

						transition left 0.1s ease-in-out, transform 0.15s ease-in-out

						&.dropped
							position relative

							border 3px solid crimson
							border-radius 50%

							&:before
								content '\f12a'

								display block

								position absolute
								top 50%
								left 50%
								z-index 1

								color crimson

								font-family 'Font Awesome 5 Free'
								font-weight 900

								transform translate(-50%, -50%)

						&.dropped2
							position relative

							border 3px solid green
							border-radius 50%

							&:before
								content '\f12a'

								display block

								position absolute
								top 50%
								left 50%
								z-index 1

								color green

								font-family 'Font Awesome 5 Free'
								font-weight 900

								transform translate(-50%, -50%)
						&:hover
							transform scale(1.2)
					
					&:hover
						.sub
							left 0 !important

</style>
